import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import Label from '@/Controls/Label';
import TypeConverter from '@/Utility/TypeConverter';
import Utilities from '@/Utility/Utilities';

export default class CheckBoxLabelFactory extends ControlFactory {

    /**
     * @override
     */
    control: Label;
    private jQueryControl: JQuery;
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    protected Label = ComponentManager.getControl<typeof Label>('Label');

    /**
     * @override
     */
    public viewModel: LabelViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        const isNullableType = TypeConverter.typeIsNullable(this.detailViewItem.dotNetTypeName);

        this.viewModel = new this.LabelViewModel({
            factory: this,
            isRequired: this.isRequired,
            isValid: this.isValid,
            isEnabled: this.isEnabled,
            invalidationText: this.invalidationText,
            parentLocator: this.locator,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            locator: this.detailViewItem.name,
            ergName: this.definePureComputed({
                read: () => {
                    if (this.isDisposed || this.context.isDisposed)
                        return null;

                    const value = this.context.genericObject.getObservable(this.detailViewItem.name)();
                    if (isNullableType && Utilities.isNullOrUndefined(value))
                        return null;
                    return value ? 'YES' : 'NO';
                }
            }),
            caption: isNullableType
                ? this.definePureComputed({
                    read: () => {
                        // Greift nur wenn ergName null ist
                        return '-';
                    }
                })
                : null,
        });

        this.control = new this.Label(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('CheckBoxLabel', CheckBoxLabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');